// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataxbeth } from "../../../icons/mono/build/icon-stataxbeth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataxbethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataxbeth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataxbethIcon.displayName = 'StataxbethIcon';
}

export default StataxbethIcon;